import type { ShopgndApiConfig } from '@shopgnd/api';
import { getIdToken } from '@/lib/auth';

async function loadAmplifyCustom(): Promise<Record<string, string>> {
  try {
    const cacheBust = import.meta.env.DEV ? `?t=${Date.now()}` : '';
    const res = await fetch(`/amplify_outputs.json${cacheBust}`, { cache: 'no-store' });
    if (!res.ok) return {};
    const outputs = (await res.json()) as { custom?: Record<string, string> };
    return outputs.custom ?? {};
  } catch {
    return {};
  }
}

let customCache: Record<string, string> | null = null;

async function getCustom(): Promise<Record<string, string>> {
  if (!customCache) customCache = await loadAmplifyCustom();
  return customCache;
}

/** Shared API config for @shopgnd/api (web). */
export const webApiConfig: ShopgndApiConfig = {
  getIdToken,
  async getCustomUrl(key: string) {
    const envByKey: Record<string, string | undefined> = {
      adminOrdersUrl: import.meta.env.VITE_ADMIN_ORDERS_URL as string | undefined,
      platformMetricsUrl: import.meta.env.VITE_PLATFORM_METRICS_URL as string | undefined,
      propertyListingUrl: import.meta.env.VITE_PROPERTY_LISTING_URL as string | undefined,
      productListingUrl: import.meta.env.VITE_PRODUCT_LISTING_URL as string | undefined,
      adminUsersUrl: import.meta.env.VITE_ADMIN_USERS_URL as string | undefined,
    };
    if (envByKey[key]) return envByKey[key]!;
    const custom = await getCustom();
    return custom[key] ?? null;
  },
};

export function invalidateApiConfigCache() {
  customCache = null;
}

export async function isAdminOrdersApiConfigured(): Promise<boolean> {
  const url = await webApiConfig.getCustomUrl('adminOrdersUrl');
  return Boolean(url);
}
